import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export class Modal extends Component {
  render() {
    const { domQuery, toggleModal } = this.props;
    // Common Modal component adds modal to domQuery element passed from modal controlling button
    return ReactDOM.createPortal(
      <div className={`CFModal ${this.props.fadeCFModal ? 'CFModal__fadeIn' : ''}`}>
        <div className={`CFModal__overlay`} onClick={toggleModal}></div>
        <div className={`CFModal__modal`}>
          {this.props.children}
        </div>
      </div>,
      document.querySelector(domQuery)
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/features/common/Modal.js